export enum LocationType {
  google_meet = "google_meet",
  zoom = "zoom",
  zoho = "zoho",
  microsoft_teams = "microsoft_teams",
  goto_meeting = "goto_meeting",
  webex = "webex",
  joinme = "joinme",

  // Custom location
  physical = "physical",
  virtual = "virtual",
  phone = "phone",

  // Invitee specified location
  ask_invitee = "ask_invitee",
  inbound_call = "inbound_call",
}

export interface Location {
  type: LocationType | string;

  // Online meeting fields
  join_url?: string;
  meeting_id?: string;
  password?: string;

  // Physical location fields
  address?: string;
  city?: string;
  state?: string;
  country?: string;
  zip_code?: string;
  latitude?: number;
  longitude?: number;
  place_id?: string;

  // Contact information
  phone?: string;
  email?: string;

  // Additional information
  name?: string;
  remarks?: string;
}
